export default __webpack_public_path__ + "static/media/navbar-subscribers-orange.5c841566.svg";